/**
 * Gem Stage Route
 *
 * Triggers loading of the gem stage when this route becomes active.
 * The actual canvas is in the parent layout (ux.tsx).
 */

import { createFileRoute } from "@tanstack/react-router";
import { useLoadStageOnMount } from "../ux";

export const Route = createFileRoute("/_immersive/demo/3d/ux/gem")({
  component: GemStageRoute,
});

function GemStageRoute() {
  useLoadStageOnMount("gem");
  return null;
}
